import { Component, Input } from '@angular/core';

@Component({
  selector: 'display-rtf-text',
  templateUrl: './display-rtf-text.component.html',
})
export class DisplayRtfTextComponent {
  @Input() text: string;
}
